<div dw-tooltip dwPlacement="topLeft" dwOverlayClassName="ag-invalid-cell-overlay"
     [dwTitle]="errorContent" [dwVisible]="errorVisible"
     *ngIf="errorVisible"></div>
<ng-template #errorContent>
  <div *ngFor="let msg of validationMessages">{{ msg.key | translate:msg.params }}</div>
</ng-template>
<div *ngIf="validateForm" [formGroup]="validateForm">
  <input [formControl]="formControl" [(ngModel)]="value" hidden >
  <div *ngIf="!formControl.valid" class="error-panel">{{label}}</div>
  <dw-badge dwStatus="default" [dwText]="label" [dwStyle]="{'background-color':color}"></dw-badge>

</div>
